export default __webpack_public_path__ + "static/media/partners.178cfb3f.svg";